import _ from 'lodash';
import axios from 'axios';
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
  postMultipartRequest,
  postCustomRequest,
  uploadEncodedFile,
  uploadEncodedFileLarge
} from '../../Common/network-call';
import { INSTANCE_URL, itemCount, APP_API_KEY } from '../../Common/constant';

export const FETCH_COURSE_DATA = 'FETCH_COURSE_DATA';
export const FETCH_CHAPTERS_DATA = 'FETCH_CHAPTERS_DATA';
export const FETCH_LESSIONS_DATA = 'FETCH_LESSIONS_DATA';
export const SHOW_SIDEBAR = 'SHOW_SIDEBAR';
export const SHOW_BACK_SCREEN = 'SHOW_BACK_SCREEN';
export const SHOW_CHAPTERS = 'SHOW_CHAPTERS';
export const OPEN_QA_MODAL_LESSON = 'OPEN_QA_MODAL_LESSON';
export const FETCH_LESSON_LIVEQA_DATA = 'FETCH_LESSON_LIVEQA_DATA';
export const OPEN_QUIZ_MODAL_LESSON = 'OPEN_QUIZ_MODAL_LESSON';
export const FETCH_DYNAMIC_FORM_RESPONSE_DATA =
  'FETCH_DYNAMIC_FORM_RESPONSE_DATA';

export const FETCH_COURSE_DATA_BY_USER_ACCESS =
  'FETCH_COURSE_DATA_BY_USER_ACCESS';

export function fetchCourseData(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/koachifyscript/mycourses`;
  var body = {
    appuserid: session.userid,
    eventid: session.eventid
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response -> ', response);
        dispatch({
          type: FETCH_COURSE_DATA,
          payload: {
            data: response.resource,
            count: response.resource.length,
            allaccess: response.allaccess
          }
        });
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function makeEmpty_CourseData() {
  return dispatch => {
    dispatch({ type: FETCH_COURSE_DATA, payload: {} });
  };
}

export function showSidebar(value) {
  return dispatch => {
    dispatch({ type: SHOW_SIDEBAR, payload: value });
  };
}

export function makeEmpty_Chapters() {
  return dispatch => {
    dispatch({ type: FETCH_CHAPTERS_DATA, payload: {} });
  };
}

export function makeEmpty_Lessions() {
  return dispatch => {
    dispatch({ type: FETCH_LESSIONS_DATA, payload: {} });
  };
}

// export function fetchChapters(session, courseid, callback) {
//   var url = `${INSTANCE_URL}/api/v2/eventify/_table/course_chapter?related=course_lessons_attachments_by_chapterid,course_lessons_by_chapterid&include_count=true&filter=courseid%3D${courseid}`;

//   return dispatch => {
//     getRequest(
//       url,
//       session,
//       dispatch,
//       data => {
//         dispatch({
//           type: FETCH_CHAPTERS_DATA,
//           payload: { data: data.resource, count: data.meta.count }
//         });
//         callback({
//           success: 1,
//           result: { response: data.resource }
//         });
//       },
//       error => {
//         callback({ success: 0, error: error });
//       }
//     );
//   };
// }

export function fetchChapters(session, courseid, callback) {
  var url = `${INSTANCE_URL}/api/v2/koachifyscript/fetchChapters`;
  var body = {
    // appuserid: session.userid,
    eventid: session.eventid,
    courseid: courseid
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response -> ', response);
        dispatch({
          type: FETCH_CHAPTERS_DATA,
          payload: {
            data: response.resource,
            count: response.resource.length
          }
        });
        callback({ success: 1, result: { response: response.resource } });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

// export function fetchLessions(session, chapterid, callback) {
//   // console.log('session: ', session);

//   var url = `${INSTANCE_URL}/api/v2/eventify/_table/course_lessons?related=course_lessons_attachments_by_lessonid,event_forms_by_quizid&include_count=true&filter=chapterid%3D${chapterid}`;

//   return dispatch => {
//     getRequest(
//       url,
//       session,
//       dispatch,
//       data => {
//         // console.log('data.resource: ', data.resource);
//         dispatch({
//           type: FETCH_LESSIONS_DATA,
//           payload: { data: data.resource, count: data.meta.count }
//         });
//         callback({
//           success: 1,
//           result: { response: data.resource }
//         });
//       },
//       error => {
//         callback({ success: 0, error: error });
//       }
//     );
//   };
// }

export function showBackScreen(value) {
  return dispatch => {
    dispatch({ type: SHOW_BACK_SCREEN, payload: value });
  };
}

export function showChapters(value) {
  return dispatch => {
    dispatch({ type: SHOW_CHAPTERS, payload: value });
  };
}

export function fetchliveqa_lesson(session, courseid, lessonid, callback) {
  var filter = encodeURI(
    `(courseid=${courseid})AND(lessonid=${lessonid})AND(eventid = ${session.eventid})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa?related=appuser_by_questionedby&include_count=true&filter=${filter}&order=createdon%20ASC`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_LESSON_LIVEQA_DATA,
          payload: { data: data.resource, count: data.meta.count }
        });
        callback({
          success: 1,
          result: { response: data.resource }
        });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function makeEmpty_LiveQA() {
  return dispatch => {
    dispatch({ type: FETCH_LESSON_LIVEQA_DATA, payload: {} });
  };
}

export function openqaModal_lesson(value) {
  return dispatch => {
    dispatch({ type: OPEN_QA_MODAL_LESSON, payload: value });
  };
}

export function addQue_liveqa_lesson(session, resource, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa`;

  var body = {
    resource: resource
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response addQue_liveqa_lesson: ', response);
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function openQuizModal_lesson(value) {
  return dispatch => {
    dispatch({ type: OPEN_QUIZ_MODAL_LESSON, payload: value });
  };
}

export function insert_into_dynamic_form_responses(
  session,
  resource,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/dynamic_form_responses`;

  var body = {
    resource: resource
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response insert_into_dynamic_form_responses: ', response);
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function fetch_dynamic_form_responses(
  session,
  courseid,
  lessonid,
  quizid,
  callback
) {
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(courseid=${courseid})AND(lessonid=${lessonid})AND(formid=${quizid})`
  );

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/dynamic_form_responses?related=*&include_count=true&filter=${filter}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_DYNAMIC_FORM_RESPONSE_DATA,
          payload: { data: data.resource, count: data.meta.count }
        });
        callback({
          success: 1,
          result: { response: data.resource }
        });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function makeEmpty_fetch_dynamic_form_responses() {
  return dispatch => {
    dispatch({ type: FETCH_DYNAMIC_FORM_RESPONSE_DATA, payload: {} });
  };
}

export function storeLessionDetails(value) {
  return dispatch => {
    dispatch({ type: FETCH_LESSIONS_DATA, payload: value });
  };
}
